import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import '../styles/VerificarCertificado.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://abraliber.com.br/api';

// Lê o código da URL de forma síncrona, antes de qualquer render ou hook
function lerCodigoDaURL() {
  try {
    return new URLSearchParams(window.location.search).get('codigo') || '';
  } catch {
    return '';
  }
}

export default function VerificarCertificado() {
  const codigoUrl = useRef(lerCodigoDaURL());

  const [codigo, setCodigo] = useState(codigoUrl.current);
  const [resultado, setResultado] = useState(null);
  // Se a URL já tem um código, começa como loading=true:
  // o usuário vê "Verificando..." imediatamente, sem flash de página vazia
  const [loading, setLoading] = useState(!!codigoUrl.current);
  const [erro, setErro] = useState('');
  const chamadaFeita = useRef(false);

  const verificar = async (cod) => {
    const c = (cod !== undefined ? cod : codigo).trim();
    if (!c) {
      setErro('Informe o código de validação.');
      return;
    }
    setLoading(true);
    setErro('');
    setResultado(null);
    try {
      const resp = await axios.post(`${API_URL}/certificados/validar`, { codigo: c });
      setResultado({ valido: true, dados: resp.data });
    } catch (e) {
      if (e.response?.status === 404) {
        setResultado({ valido: false });
      } else {
        setErro('Erro ao consultar. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Dispara a verificação uma única vez ao montar, se há código na URL
    if (codigoUrl.current && !chamadaFeita.current) {
      chamadaFeita.current = true;
      verificar(codigoUrl.current);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="verificar-page">
      <div className="verificar-container">
        <div className="verificar-header">
          <div className="verificar-logo-area">
            <span className="verificar-institution">ABRALIBER</span>
            <span className="verificar-subtitle">Associação Brasileira do Livre Saber</span>
          </div>
          <h1 className="verificar-title">Verificação de Autenticidade</h1>
          <p className="verificar-desc">
            Insira o código de validação impresso no certificado para confirmar sua autenticidade.
          </p>
        </div>

        <div className="verificar-form-area">
          <div className="verificar-input-group">
            <label htmlFor="codigo-input">Código de Validação</label>
            <input
              id="codigo-input"
              type="text"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value.toUpperCase())}
              placeholder="ABRALIBER-0000-000-0000-2026"
              onKeyDown={(e) => e.key === 'Enter' && verificar()}
              className="verificar-input"
              spellCheck={false}
            />
            <button
              onClick={() => verificar()}
              disabled={loading}
              className="verificar-btn"
            >
              {loading ? 'Verificando...' : 'Verificar Certificado'}
            </button>
          </div>
          {erro && <p className="verificar-erro">{erro}</p>}
        </div>

        {resultado && (
          <div className={`verificar-resultado ${resultado.valido ? 'valido' : 'invalido'}`}>
            {resultado.valido ? (
              <>
                <div className="resultado-icone valido-icone">✓</div>
                <h2 className="resultado-titulo">Certificado Autêntico</h2>
                <p className="resultado-desc">Este certificado é válido e foi emitido pela ABRALIBER.</p>
                <div className="resultado-dados">
                  <div className="dado-row">
                    <span className="dado-label">Aluno</span>
                    <span className="dado-valor">{resultado.dados.student_name}</span>
                  </div>
                  <div className="dado-row">
                    <span className="dado-label">Curso</span>
                    <span className="dado-valor">{resultado.dados.course_title}</span>
                  </div>
                  <div className="dado-row">
                    <span className="dado-label">Nota Final</span>
                    <span className="dado-valor">{resultado.dados.score}/100</span>
                  </div>
                  <div className="dado-row">
                    <span className="dado-label">Conclusão</span>
                    <span className="dado-valor">{resultado.dados.completion_date}</span>
                  </div>
                  <div className="dado-row">
                    <span className="dado-label">Código</span>
                    <span className="dado-valor codigo-destaque">{resultado.dados.certificate_code}</span>
                  </div>
                </div>
                <p className="resultado-legal">
                  Válido em todo território nacional • Lei nº 9.394/96 • Decreto nº 5.154/04
                </p>
              </>
            ) : (
              <>
                <div className="resultado-icone invalido-icone">✗</div>
                <h2 className="resultado-titulo">Certificado Não Encontrado</h2>
                <p className="resultado-desc">
                  O código informado não corresponde a nenhum certificado emitido pela ABRALIBER.
                  Verifique se o código foi digitado corretamente.
                </p>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
